import {useEffect} from 'react'

const useHandlePostScanQR = (
	hasScannedData,
	scannedData,
	scanResult,
	isBottomSheetOpen,
	hasCalledApiRef,
	postScanQR
) => {
	useEffect(() => {
		if (
			hasScannedData &&
			scannedData &&
			!hasCalledApiRef.current &&
			!scanResult &&
			!isBottomSheetOpen
		) {
			hasCalledApiRef.current = true
			postScanQR(scannedData)
		}
	}, [hasScannedData, scannedData, scanResult, isBottomSheetOpen])
}

export default useHandlePostScanQR
